'use strict';

var featureFlagsComponent = {
  bindings: {},
  controller: /*@ngInject*/ function($http, REST_URL) {
    var _self = this;
    var FLAG_ID = 'global-search-v2-nav';

    _self.flag = null;
    _self.loading = true;
    _self.error = false;

    _self.$onInit = function() {
      $http.get(REST_URL.base + '/feature-flags')
        .then(function(response) {
          var flags = response.data || [];
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].id === FLAG_ID) {
              _self.flag = flags[i];
              break;
            }
          }
        })
        .catch(function() {
          _self.error = true;
        })
        .finally(function() {
          _self.loading = false;
        });
    };
  },
  templateUrl: 'templates/partials/admin/featureFlags.tpl.html'
};

module.exports = featureFlagsComponent;
